import { IFeatureListItems } from '@/pages/home/components/features/feature.data.tsx';
import { FC } from 'react';

const FeatureRow: FC<{ data: IFeatureListItems }> = ({ data }) => {
  return (
    <section>
      <div className="container">
        <div className="grid grid-cols-2 gap-10">
          {data.position === 'left' && (
            <div className="max-w-[370px] m-auto">
              <img src={data.image} alt="FeatureOne" />
            </div>
          )}
          <div className="grid grid-cols-1 gap-10">
            {data.features.map(item => {
              return (
                <div key={item.title.trim().toLowerCase()}>
                  <div className="flex gap-5">
                    <div className="w-[80px]">
                      <img src={item.icon} alt={item.title} />
                    </div>
                    <div className="w-[calc(100%-80px)]">
                      <h3 className="text-xl mb-5">{item.title}</h3>
                      <p className="text-sm leading-6">{item.info}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {data.position === 'right' && (
            <div className="max-w-[370px] m-auto">
              <img src={data.image} alt="FeatureOne" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeatureRow;
